/**
 *
 * BIGTINCAN - CONFIDENTIAL
 *
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of BigTinCan Mobile Pty Ltd and its suppliers,
 * if any. The intellectual and technical concepts contained herein are proprietary to BigTinCan Mobile Pty Ltd and its
 * suppliers and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or reproduction of this material is strictly forbidden unless prior
 * written permission is obtained from BigTinCan Mobile Pty Ltd.
 *
 * @package app.bigtincan.dsr
 * @copyright 2010-2020 BigTinCan Mobile Pty Ltd
 * @author Shibu Bhattarai <shibu.bhattarai@bigtincan.com>
 */

 import { TeamEvent, TeamEventCard } from '../../model/api/graph';

export const GET_MEETING_REQUEST = 'GET_MEETING_REQUEST';
export const GET_MEETING_SUCCESS = 'GET_MEETING_SUCCESS';
export const GET_MEETING_FAIL = 'GET_MEETING_FAIL';

export const ADD_MEETING_REQUEST = 'ADD_MEETING_REQUEST';
export const ADD_MEETING_SUCCESS = 'ADD_MEETING_SUCCESS';
export const ADD_MEETING_FAIL = 'ADD_MEETING_FAIL';


export const REMOVE_MEETING_CONTENT_REQUEST = 'REMOVE_MEETING_CONTENT_REQUEST';
export const REMOVE_MEETING_CONTENT_SUCCESS = 'REMOVE_MEETING_CONTENT_SUCCESS';



export const GET_TEAM_EVENT_REQUEST = 'GET_TEAM_EVENT_REQUEST';
export const GET_TEAM_EVENT_SUCCESS = 'GET_TEAM_EVENT_SUCCESS';

export const GET_TEAM_EVENTS_REQUEST = 'GET_TEAM_EVENTS_REQUEST';
export const GET_TEAM_EVENTS_SUCCESS = 'GET_TEAM_EVENTS_SUCCESS';

export const SELECT_RECOMMANDATION_STORY = 'SELECT_RECOMMANDATION_STORY';
export const SELECT_BOOKMARK = 'SELECT_BOOKMARK';
export const SELECT_BOOKMARK_ADD = 'SELECT_BOOKMARK_ADD';
export const ADD_FILE_TO_CURRENT_SELECTION = 'ADD_FILE_TO_CURRENT_SELECTION';
export const UPDATE_REMOVE_FILE_LIST = "UPDATE_REMOVE_FILE_LIST";


export const RECOMMENDATIONS_SELECT_ALL = 'RECOMMENDATIONS_SELECT_ALL';
export const RECOMMENDATIONS_SELECT_ITEM = 'RECOMMENDATIONS_SELECT_ITEM';
export const BOOKMARK_SELECT_ITEM = 'BOOKMARK_SELECT_ITEM';

export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const FILES_ADDED_MESSAGE = 'FILES_ADDED_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const SELECTED_THEME = 'SELECTED_THEME';

export interface MeetingContent {
    id: string;
    storyId: number;
    hubShareItemId: number;
    hubShareItemUrl: string;
    fileId: number;
    fileName: string;
    category: string;
    order: number;
} export interface Attendee {
    id: string;
    email: string;
    name: string;
    meetingId: string;
}

export interface Meeting {
    id: string;
    name: string;
    createdDate: Date;
    meetingDate: Date;
    teamMeetingId: string;
    createdBy: string;
    userEmail?: any;
    hubEmail: string;
    descriptions: string;
    hubShareUrl: string;
    attendees: Attendee[];
    meetingContents: MeetingContent[];
}
export interface MeetingState {
    adding: boolean;
    removing: boolean;
    loading: boolean;
    message: string;
    filesAddedMessage: string,
    currentBookmarkSelection : number[],
    selectedBookmarkId: number,
    selectRecommendedStory: number,
    selectedFiles: {
        id: number,
        storyId: number,
        checked: boolean
    }[],
    selectedFilesForRemove: number[],
    teamEvent: TeamEvent | null,
    teamEvents: TeamEventCard[] | null,
    selectedDate: Date,
    currentMeeting: Meeting,
    theme : string,
    error?: {
        message: string;
        status: number;
    };
}

export interface GetMeetingRequestAction {
    type: typeof GET_MEETING_REQUEST;
    meetingId: string;
}

export interface GetMeetingSuccessAction {
    type: typeof GET_MEETING_SUCCESS;
    payload: Meeting;
    message: string
}

export interface GetMeetingFailedAction {
    type: typeof GET_MEETING_FAIL;
    error: {
        message: string;
        status: number;
    };
}

export interface AddMeetingRequestAction {
    type: typeof ADD_MEETING_REQUEST;
    meetingId: string;
}

export interface AddMeetingSuccessAction {
    type: typeof ADD_MEETING_SUCCESS;
    payload: Meeting;
}

export interface AddMeetingFailedAction {
    type: typeof ADD_MEETING_FAIL;
    error: {
        message: string;
        status: number;
    };
}


export interface GetTeamEventRequestAction {
    type: typeof GET_TEAM_EVENT_REQUEST;
    meetingId: string;
}

export interface GetTeamEventSuccessAction {
    type: typeof GET_TEAM_EVENT_SUCCESS;
    payload: TeamEvent;
}

export interface GetTeamEventsRequestAction {
    type: typeof GET_TEAM_EVENTS_REQUEST;
    scheduledDate: Date;
}

export interface GetTeamEventsSuccessAction {
    type: typeof GET_TEAM_EVENTS_SUCCESS;
    payload: TeamEventCard[];
    scheduledDate: Date;
}

export interface SelectRecommendationAction {
    type: typeof SELECT_RECOMMANDATION_STORY;
    storyId: number;
    files: number[];
}

export interface SelectBookmarkAction {
    type: typeof SELECT_BOOKMARK,
    bookmarkId: number;
    items: {
        id: number;
        storyId: number;
    }[];
}

export interface SelectBookmarkAddAction {
    type: typeof SELECT_BOOKMARK_ADD,
    bookmarkId: number;
    items: {
        id: number;
        storyId: number;
        checked:boolean;
    }[];
}

export interface AddFileToCurrentSelectionAction {
    type: typeof ADD_FILE_TO_CURRENT_SELECTION;
    fileId: {
        id: number;
        checked: boolean;
    }
}

export interface AddFileToRemoveListAction {
    type: typeof UPDATE_REMOVE_FILE_LIST;
    fileId: number;
    action: 'add' | 'remove';
}

export interface RecommendationSelectAllAction {
    type: typeof RECOMMENDATIONS_SELECT_ALL;
    payload: boolean
}

export interface RecommendationSelectItemAction {
    type: typeof RECOMMENDATIONS_SELECT_ITEM;
    fileId: number;
    checked: boolean;
}

export interface BookmarkSelectItemAction {
    type: typeof BOOKMARK_SELECT_ITEM;
    fileId: number;
    checked: boolean;
    storyId: number;
}

export interface InMeetingSearch {
    type: typeof FILES_ADDED_MESSAGE;
    filesAddedMessage: string;
    currentBookmarkSelection: number[];
}

export interface teamsTheme {
    type: typeof SELECTED_THEME;
    theme: string; 
}
 

export interface RemoveMeetingContentRequestAction {
    type: typeof REMOVE_MEETING_CONTENT_REQUEST;
}

export interface RemoveMeetingContentRequestSuccessAction {
    type: typeof REMOVE_MEETING_CONTENT_SUCCESS;
}
 
export interface ClearMessageAction {
    type: typeof CLEAR_MESSAGE;
}

export interface UpdateMessageAction {
    type: typeof UPDATE_MESSAGE;
    message: string;
}
export type MeetingKnownAction =
  | GetMeetingRequestAction
  | GetMeetingSuccessAction
  | GetMeetingFailedAction
  | AddMeetingRequestAction
  | AddMeetingSuccessAction
  | GetTeamEventRequestAction
  | GetTeamEventSuccessAction
  | GetTeamEventsRequestAction
  | GetTeamEventsSuccessAction
  | AddMeetingFailedAction
  | SelectRecommendationAction
  | SelectBookmarkAction
  | SelectBookmarkAddAction
  | AddFileToCurrentSelectionAction
  | AddFileToRemoveListAction
  | RecommendationSelectItemAction
  | ClearMessageAction
  | RemoveMeetingContentRequestAction
  | RemoveMeetingContentRequestSuccessAction
  | RecommendationSelectAllAction
  | BookmarkSelectItemAction
  | InMeetingSearch
  | UpdateMessageAction
  | teamsTheme;
